import React from 'react'
import ConfigRetornoRangeField from './ConfigRetornoRangeField'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import ConfigRetornoTextField from './ConfigRetornoTextField'
import ConfigRetornoChipsField from './ConfigRetornoChipsField'
import ConfigRetornoCodigosConfiguracao from './ConfigRetornoCodigosConfiguracao'

/**
 * Exemplo de formulário customizado para edição de configArquivoRetorno
 * Este é apenas um exemplo - você deve criar o formulário real baseado
 * na estrutura específica do seu JSON
 *
 * @param {Object} data - Dados atuais do JSON
 * @param {Function} onChange - Função para atualizar um campo: onChange(field, value)
 * @param {Object} errors - Objeto com erros de validação por campo
 * @returns {JSX.Element}
 */
export function renderConfigArquivoRetornoForm(data, onChange, errors) {
  const messages = storage.getAppLabels('configuracaoboleto')

  const codigosLiquidacaoErrors = typeof errors.codigos_liquidacao === 'object' ? errors.codigos_liquidacao : {}
  const codigosLiquidacaoError = typeof errors.codigos_liquidacao === 'string' ? errors.codigos_liquidacao : null

  return (
    <>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.legado}
            onChange={(value) => onChange('legado', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.legado')}
            errors={errors.legado || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.nosso_numero}
            onChange={(value) => onChange('nosso_numero', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.nossonumero')}
            errors={errors.nosso_numero || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.numero_documento}
            onChange={(value) => onChange('numero_documento', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.numerodocumento')}
            errors={errors.numero_documento || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.valor_pago}
            onChange={(value) => onChange('valor_pago', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valorpago')}
            errors={errors.valor_pago || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.data_pagamento}
            onChange={(value) => onChange('data_pagamento', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.datapagamento')}
            errors={errors.data_pagamento || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.data_vencimento}
            onChange={(value) => onChange('data_vencimento', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.datavencimento')}
            errors={errors.data_vencimento || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.data_efetivacao_credito}
            onChange={(value) => onChange('data_efetivacao_credito', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.dataefetivacaocredito')}
            errors={errors.data_efetivacao_credito || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.valor_juros_multa_encargos}
            onChange={(value) => onChange('valor_juros_multa_encargos', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valorjurosmultaencargos')}
            errors={errors.valor_juros_multa_encargos || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.valor_desconto}
            onChange={(value) => onChange('valor_desconto', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valordesconto')}
            errors={errors.valor_desconto || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.codigo_ocorrencia}
            onChange={(value) => onChange('codigo_ocorrencia', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigoocorrencia')}
            errors={errors.codigo_ocorrencia || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.motivo_ocorrencia}
            onChange={(value) => onChange('motivo_ocorrencia', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.motivoocorrencia')}
            errors={errors.motivo_ocorrencia || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.valor_liquido_creditado}
            onChange={(value) => onChange('valor_liquido_creditado', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valorliquidocreditado')}
            errors={errors.valor_liquido_creditado || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.valor_boleto}
            onChange={(value) => onChange('valor_boleto', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.valorboleto')}
            errors={errors.valor_boleto || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.nome_pagador}
            onChange={(value) => onChange('nome_pagador', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.nomepagador')}
            errors={errors.nome_pagador || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.documento_pagador}
            onChange={(value) => onChange('documento_pagador', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.documentopagador')}
            errors={errors.documento_pagador || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.identificacao_titulo}
            onChange={(value) => onChange('identificacao_titulo', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.identificacaotitulo')}
            errors={errors.identificacao_titulo || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoRangeField
            value={data.carteira}
            onChange={(value) => onChange('carteira', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.carteira')}
            errors={errors.carteira || {}}
          />
        </div>

        <div className="p-col-12 p-md-6 p-lg-4">
          <ConfigRetornoTextField
            value={data.data_pagamento_formato}
            onChange={(value) => onChange('data_pagamento_formato', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.datapagamentoformato')}
            name="data_pagamento_formato"
            label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.formato')}
            error={errors.data_pagamento_formato}
          />
        </div>

        <div className="p-col-12">
          <ConfigRetornoChipsField
            value={data.codigo_liquidado}
            onChange={(value) => onChange('codigo_liquidado', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigoliquidado')}
            name="codigo_liquidado"
            label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigoliquidado')}
            separator=","
            error={errors.codigo_liquidado}
          />
        </div>
        <div className="p-col-12">
          <ConfigRetornoCodigosConfiguracao
            value={data.codigos_liquidacao}
            onChange={(value) => onChange('codigos_liquidacao', value)}
            title={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.codigosliquidacao')}
            error={codigosLiquidacaoError}
            errors={codigosLiquidacaoErrors}
          />
        </div>
      </div>
    </>
  )
}

/**
 * Função de validação customizada para configArquivoRetorno
 *
 * @param {Object} data - Dados a serem validados
 * @returns {Object|null} - Objeto com erros ou null se válido
 */
export function validateConfigArquivoRetorno(data) {
  const errors = {}

  // Validação de campos range (inicio e fim)
  // Nota: -1 é permitido e indica que o campo não será usado no backend
  const validateRangeField = (fieldName, fieldValue) => {
    const fieldErrors = {}

    if (fieldValue) {
      if (fieldValue.inicio != null && fieldValue.fim != null) {
        // Permitir -1 como valor especial (campo inválido/não usado)
        const inicioValido = fieldValue.inicio === -1 || fieldValue.inicio >= 0
        const fimValido = fieldValue.fim === -1 || fieldValue.fim >= 0

        if (!inicioValido) {
          fieldErrors.inicio = 'Início deve ser -1 ou maior ou igual a zero'
        }
        if (!fimValido) {
          fieldErrors.fim = 'Fim deve ser -1 ou maior ou igual a zero'
        }

        // Validar ordem apenas se ambos forem >= 0
        if (inicioValido && fimValido && fieldValue.inicio >= 0 && fieldValue.fim >= 0) {
          if (fieldValue.inicio > fieldValue.fim) {
            fieldErrors.inicio = 'Início deve ser menor ou igual ao Fim'
          }
        }
      }
    }

    if (Object.keys(fieldErrors).length > 0) {
      errors[fieldName] = fieldErrors
    }
  }

  // Validar todos os campos range
  validateRangeField('legado', data.legado)
  validateRangeField('nosso_numero', data.nosso_numero)
  validateRangeField('numero_documento', data.numero_documento)
  validateRangeField('valor_pago', data.valor_pago)
  validateRangeField('data_pagamento', data.data_pagamento)
  validateRangeField('data_vencimento', data.data_vencimento)
  validateRangeField('data_efetivacao_credito', data.data_efetivacao_credito)
  validateRangeField('valor_juros_multa_encargos', data.valor_juros_multa_encargos)
  validateRangeField('valor_desconto', data.valor_desconto)
  validateRangeField('codigo_ocorrencia', data.codigo_ocorrencia)
  validateRangeField('motivo_ocorrencia', data.motivo_ocorrencia)
  validateRangeField('valor_liquido_creditado', data.valor_liquido_creditado)
  validateRangeField('valor_boleto', data.valor_boleto)
  validateRangeField('nome_pagador', data.nome_pagador)
  validateRangeField('documento_pagador', data.documento_pagador)
  validateRangeField('identificacao_titulo', data.identificacao_titulo)
  validateRangeField('carteira', data.carteira)

  // Validar campo de texto data_pagamento_formato
  if (data.data_pagamento_formato && data.data_pagamento_formato.length > 50) {
    errors.data_pagamento_formato = 'Formato deve ter no máximo 50 caracteres'
  }

  // Validar array codigo_liquidado
  if (data.codigo_liquidado && Array.isArray(data.codigo_liquidado)) {
    if (data.codigo_liquidado.length === 0) {
      errors.codigo_liquidado = 'Adicione pelo menos um código de liquidação'
    }
  }

  // Validar objeto codigos_liquidacao
  if (data.codigos_liquidacao) {
    const codigosKeys = Object.keys(data.codigos_liquidacao)
    if (codigosKeys.length === 0) {
      errors.codigos_liquidacao = 'Adicione pelo menos uma configuração de código'
    } else {
      const codigosErrors = {}

      // Validar cada código
      for (const codigo of codigosKeys) {
        const config = data.codigos_liquidacao[codigo] || {}
        const codigoErrors = {}

        if (!config.descricao || config.descricao.trim() === '') {
          codigoErrors.descricao = 'Descrição é obrigatória'
        }

        const posicoes = config.codigos_relacionados?.posicoes
        if (posicoes) {
          const { inicio, fim } = posicoes
          const posicoesErrors = {}

          if (inicio == null) {
            posicoesErrors.inicio = 'Início é obrigatório'
          }
          if (fim == null) {
            posicoesErrors.fim = 'Fim é obrigatório'
          }

          if (inicio != null && fim != null && inicio > fim) {
            posicoesErrors.inicio = 'Início deve ser menor ou igual ao Fim'
          }

          if (Object.keys(posicoesErrors).length > 0) {
            codigoErrors.codigos_relacionados = {
              ...codigoErrors.codigos_relacionados,
              posicoes: posicoesErrors,
            }
          }
        } else {
          codigoErrors.codigos_relacionados = {
            ...codigoErrors.codigos_relacionados,
            posicoes: {
              inicio: 'Início é obrigatório',
              fim: 'Fim é obrigatório',
            },
          }
        }

        const valores = config.codigos_relacionados?.valores
        if (!Array.isArray(valores) || valores.length === 0) {
          codigoErrors.codigos_relacionados = {
            ...codigoErrors.codigos_relacionados,
            valores: 'Valores é obrigatório',
          }
        }

        if (Object.keys(codigoErrors).length > 0) {
          codigosErrors[codigo] = codigoErrors
        }
      }

      if (Object.keys(codigosErrors).length > 0) {
        errors.codigos_liquidacao = codigosErrors
      }
    }
  }

  return Object.keys(errors).length > 0 ? errors : null
}
